import React from 'react';
import { ClipboardList } from 'lucide-react';
import { Link } from 'react-router-dom';
import { products } from '../../data/mockData';
import { ACTIVATION_FORM_URL, ACTIVATION_PAGE } from '../../data/intake';

// Billing is handled outside the site — one universal activation form (Jotform) for every panel.
export const ORDER_FORM_URL = ACTIVATION_FORM_URL;
export const ORDER_PAGE = ACTIVATION_PAGE;

export const orderPath = (panelId) => products.some((panel) => panel.id === panelId)
  ? `${ORDER_PAGE}?panel=${encodeURIComponent(panelId)}` : ORDER_PAGE;

export const OrderButton = ({ children = 'FIND MY PANEL', panelId, className = 'btn-cta w-full', testId, onClick }) => (
  <Link to={orderPath(panelId)} className={className} onClick={onClick} data-testid={testId}>
    <ClipboardList className="w-4 h-4" /> {children}
  </Link>
);
